export function getConfig(token) {
  return {
    headers: {
      'x-access-token': token,
    },
  };
}
